import Helper from "../Helper";
import ButtonWithAnimation from "../buttons/ButtonWithAnimation";

/**
 * This class the cart that is not in reservation module.
 */
export default class Cart {
    constructor()
    {
        this.cart = $("[data-cart]");
        this.priceDetailModal = undefined;
        this.init();
    }

    init()
    {
        $(document).ready(() => {
            cartScroll();

            if (this.cart.length > 0) {
                this.buttonWithAnimation = new ButtonWithAnimation("checkYourReservationButton", "#cart-section");
                this.addedRoomToCartModal = $('#added_to_room');
                this.deletedFromRoomModal = $('#deleted_from_room');
            }
        });
    }
  /**
   * This function adds room to cart.
   *
   * @param {Element} addElement that has all sufficient data
   */
    addRoomToCart(addElement)
    {
        addElement = $(addElement);

        if ($(addElement).attr('disabled')) {
            return;
        }

        let adults = addElement.data("adults");
        let children = addElement.data("children");
        let childrenAges = JSON.parse(
            JSON.stringify(addElement.data("childrenAges"))
        );
        let mealId = addElement.data("mealId");
        let secondary = addElement.data("secondary");
        let hotelID = addElement.data("hotelId");
        let roomID = addElement.data("selectButtonRoomId");

        $.ajax({
            headers: { "X-App-Locale": $('[name="country"]').attr("content") },
            url: window.location.origin + "/api/cart/add/room",
            method: "post",
            data: {
                hotel_id: hotelID,
                adults: adults,
                children: children,
                childrenAges: childrenAges,
                meal: mealId,
                secondary: secondary,
                room_id: roomID,
                _token: $('meta[name="csrf-token"]').attr("content")
            },
            dataType: "json",
            error: (data) => {
                $('#added_to_room_failed').modal('show');
            },
            success: (data) => {
                if (!data.allotmentCanBeAdded) {
                    $('[data-select-button-room-id="'+roomID+'"]').attr('disabled', true);
                    $('[data-select-button-room-id="'+roomID+'"]').removeAttr('data-hide-popup');
                }

                $('.totals-condition-message').html(data.totalsConditionMessage);

                this.cart.find("[data-cart-items]").find('[data-cart-item]').remove();
                this.cart.find("[data-cart-items]").append(data.view);
                this.updateCartTotal(data.cartPrice);
                window.elementsCounters["cart"].recalculatePositions();

                if (this.cart.find("[data-cart-item]").length > 0) {
                    this.cart.find("[data-cart-empty]").addClass("hidden-mvio");
                    this.cart.find("[data-step-forward]").removeAttr("disabled");
                    this.cart.find("[data-step-forward]").attr("data-hide-popup", '');
                }

                this.addedRoomToCartModal.modal('show');

                setTimeout(() => {
                    this.addedRoomToCartModal.modal('hide');
                }, 1500);

                if (Helper.isMobileOrLower()) {
                    this.buttonWithAnimation.showButton(data.cartPrice);
                } else {
                    this.buttonWithAnimation.updatePrice(data.cartPrice);
                }

                cartScroll();
            }
        });
    }

  /**
   * Function that opens modal that asks user if he wants to remove room
   * It also sets tempRoomId value
   *
   * @param {String}tempRoomId
   */
    removeRoomModal(tempRoomId)
    {
        this.tempRoomId = tempRoomId;

        if (Helper.isMobileOrLower()) {
            this.deletedFromRoomModal.modal('show');
        } else {
            this.removeRoom();
        }
    }

    /**
    * Will remove given room from a cart.
    */
    removeRoom()
    {
        $.ajax({
            headers: { "X-App-Locale": $('[name="country"]').attr("content") },
            url: window.location.origin + "/api/delete/cart/room",
            method: "post",
            data: {
                room_id: this.tempRoomId,
                _token: $('meta[name="csrf-token"]').attr("content"),
            },
            dataType: "json",
            success: (data) => {
                if (data.result) {
                    $('[data-select-button-room-id="' + data.roomID + '"]').attr('disabled', false);
                    $('[data-select-button-room-id="' + data.roomID + '"]').attr('data-hide-popup', '');

                    if ((window.steppers['cart']?.currentStep ?? -1) === 0) {
                        let viewDestination = $(
                            '[data-view-destination="roomsView"]'
                        );
                        $("[data-loader]").show();
                        viewDestination.html("");

                        window.searches['rooms'].searchAjax();
                    }

                    $('.totals-condition-message').html(data.totalsConditionMessage);

                    this.updateCartTotal(data.cartPrice);
                    this.cart.find('[data-cart-item="' + this.tempRoomId + '"]').remove();
                    window.elementsCounters["cart"].recalculatePositions();

                    if (this.cart.find("[data-cart-item]").length <= 0) {
                        let viewsDestination = $('[data-view-destination="roomsView"]');
                        let offset = $('[data-header-sticky]').outerHeight() + $('[data-extras]').outerHeight() + 10;
                        Helper.scrollToElement(Helper.isMobileOrLower() ? viewsDestination : viewsDestination.parent(), offset * -1, 0);

                        this.cart.find("[data-cart-empty]").removeClass("hidden-mvio");
                        this.cart.find("[data-step-forward]").attr("disabled", true);
                        this.cart.find("[data-step-forward]").removeAttr('data-hide-popup')

                        if ($('[data-tabs-toggles]').is(":visible")) {
                            $('[data-search-submit="rooms"]').click();
                            $('[data-step-back]').addClass('hidden-mvio');
                        }
                    }

                    this.buttonWithAnimation.updatePrice(data.cartPrice);
                    cartScroll();
                }
            }
        });
    }

  /**
   * This function updates cart total price.
   *
   * @param {*} price
   */
    updateCartTotal(price)
    {
        this.cart.find("[data-cart-total]").html(Helper.formatPrice(price));
    }

  /**
   * This function updates price of a cart item in price detail
   *
   * @param {String} tempRoomId
   * @param {Object} prices Keys should be 'price' and 'discountedPrice'
   */
    updateCartItemPricesPriceDetail(tempRoomId, prices)
    {
        let cartItem = this.cart.find('[data-cart-item-price-detail="' + tempRoomId + '"]');
        let priceWithoutSpaces = prices.price.replace(/\s/g, '');
        let priceDiscountedWithoutSpaces = prices.discountedPrice.replace(/\s/g, '');
        let priceIsTheSame = parseFloat(priceWithoutSpaces) == parseFloat(priceDiscountedWithoutSpaces);
        for (const key of Object.keys(prices)) {
            cartItem
            .find('[data-cart-item-price-detail-price="' + key + '"]')
            .html(Helper.formatPrice(prices[key]));
        }

        if (priceIsTheSame) {
            let discountedPrice = cartItem.find('[data-cart-item-price-detail-price="discountedPrice"]');
            $(discountedPrice).removeClass('green-dark');

            let fullPrice = cartItem.find('[data-cart-item-price-detail-price="price"]');
            $(fullPrice).hide();
        }
    }

    /**
    * This function updates price of a cart item.
    *
    * @param {String} tempRoomId
    * @param {Object} prices Keys should be 'price' and 'discountedPrice'
    */
    updateCartItemPrices(tempRoomId, prices)
    {
        let cartItem = this.cart.find('[data-cart-item="' + tempRoomId + '"]');
        let priceWithoutSpaces = prices.price.replace(/\s/g, '');
        let priceDiscountedWithoutSpaces = prices.discountedPrice.replace(/\s/g, '');
        let priceIsTheSame = parseFloat(priceWithoutSpaces) == parseFloat(priceDiscountedWithoutSpaces);

        for (const key of Object.keys(prices)) {
            cartItem
            .find('[data-cart-item-price="' + key + '"]')
            .html(Helper.formatPrice(prices[key]));
        }

        let discountedPrice = cartItem.find('[data-cart-item-price="discountedPrice"]');
        let fullPrice = cartItem.find('[data-cart-item-price="price"]');

        if (priceIsTheSame) {
            $(discountedPrice).removeClass('green-dark');
            $(fullPrice).hide();
        } else {
            $(fullPrice).show();
            $(discountedPrice).addClass('green-dark');
        }
    }

  /**
   * This function will add treatment to given room in cart.
   * After that it updates price of room in cart.
   *
   * @param {String} tempRoomId
   * @param {String} treatmentType
   * @param {Number} treatmentId
   */
    addTreatmentToRoom(tempRoomId, treatmentType, treatmentId)
    {
        let count = window.priceCounters[treatmentType + "_" + treatmentId].getCount();

        $.ajax({
            headers: { "X-App-Locale": $('[name="country"]').attr("content") },
            url: window.location.origin + "/api/set/cure/to_room",
            method: "post",
            data: {
                room_id: tempRoomId,
                ID: treatmentId,
                type: treatmentType,
                count: count,
                _token: $('meta[name="csrf-token"]').attr("content"),
            },
            dataType: "json",
            success: (data) => {
                this.updateCartItemPrices(tempRoomId, data);
                this.updateCartTotal(data.cartPrice);
                $("#treatment_add").modal('hide');
                window.priceCounters[treatmentType + "_" + treatmentId].resetCounter();
                this.addedRoomToCartModal.modal('show');

                setTimeout(() => {
                    this.addedRoomToCartModal.modal('hide');
                }, 1500);
            }
        });
    }

  /**
   * Function that removes treatment/package from cart in real time
   *
   * @param {Element} e clicked element
   * @param {String} type package/cure
   */
    removeTreatmentPackageFromRoom(e, type)
    {
        let entityID = $(e).data("entityId");
        let tempRoomID = $(e).data("roomId");

        $.ajax({
            headers: {
                "X-App-Locale": $('[name="country"]').attr("content"),
            },
            url: window.location.origin + "/api/remove/cure/to_room",
            method: "post",
            data: {
                roomID: tempRoomID,
                id: entityID,
                type: type,
                _token: $('meta[name="csrf-token"]').attr("content"),
            },
            dataType: "json",
            success: (data) => {
                this.updateCartItemPrices(tempRoomID, data);
                this.updateCartItemPricesPriceDetail(tempRoomID, data);
                this.updateCartTotal(data.cartPrice);
                $(e).parents('[data-removeTreatmentPackage]').remove();
            }
        });
    }

  /**
   * Function that generates price detail modal with real time data
   *
   * @param {Element} element
   * @param {String} roomID temp room id in cart
   */
    generatePriceDetailModal(element, roomID)
    {
        if ($(element).attr('disabled') === "disabled") {
            return false;
        }

        $(element).attr('disabled', true);

        $.ajax({
            headers: {
                "X-App-Locale": $('[name="country"]').attr("content"),
            },
            url: window.location.origin + "/api/price_detail",
            method: "post",
            data: {
                room_id: roomID,
                _token: $('meta[name="csrf-token"]').attr("content"),
            },
            dataType: "json",
            success: (data) => {
                $('[data-fullscreen-modal="price_detail"]').html(data.view);
                this.priceDetailModal = $("#price_detail");
                this.priceDetailModal.modal('show');
                $(element).attr('disabled', false);
            }
        });
    }
}

export function cartScroll() {
    var paddingOffset = 130;
    var hotelRooms = $('#hotel-rooms');
    var stickyBlock = document.getElementById('sticky-block');
    var cartSection = $(stickyBlock).find('#cart-section').first();
    var callCenter = $(stickyBlock).find('#call-centre-section').first();
    var startAnchor = document.getElementById('sticky-anchor-start')?.getBoundingClientRect()?.top ?? 0;
    var endAnchor = document.getElementById('sticky-anchor-end')?.getBoundingClientRect()?.top ?? 0;
    var stickyHeight = stickyBlock?.offsetHeight ?? 0;

    if (stickyBlock !== null) {
        if (hotelRooms.height() >= (stickyBlock?.offsetHeight ?? 0) && window.innerWidth > window.mapBreakpoint) {
            if (startAnchor <= paddingOffset) {
                stickyBlock.style.position = 'fixed';
                stickyBlock.style.top = paddingOffset + 'px';
            } else {
                stickyBlock.style.position = 'static';
                stickyBlock.style.top = null;
            }

            if (endAnchor - stickyHeight <= paddingOffset) {
                stickyBlock.style.position = 'fixed';
                stickyBlock.style.top = (endAnchor - stickyHeight) + 'px';
            }

            stickyBlock.style.maxHeight = '100vh';
            cartSection.css('max-height', window.innerHeight - callCenter.height() - (paddingOffset + 40) + 'px');
        } else {
            stickyBlock.style.position = 'static';
            stickyBlock.style.top = null;
            stickyBlock.style.maxHeight = null;
            cartSection.css('max-height', '');
        }

        updateGradientVisibility();
    }
}

window.addEventListener('scroll', cartScroll);
window.addEventListener('resize', cartScroll);

const scrollableDiv = document.querySelector('.scrollable-div');

function updateGradientVisibility() {
    if (scrollableDiv !== null) {
        const atTop = scrollableDiv.parentElement.scrollTop === 0;
        const atBottom = scrollableDiv.parentElement.scrollHeight <= scrollableDiv.parentElement.clientHeight + scrollableDiv.parentElement.scrollTop + 10;

        scrollableDiv.classList.toggle('at-top', atTop);
        scrollableDiv.classList.toggle('at-bottom', atBottom);
    }
}

scrollableDiv?.parentElement?.addEventListener('scroll', updateGradientVisibility);
